import { apiSlice } from "app/api/apiSlice"


export const employmentApiSlice = apiSlice.injectEndpoints({
    // tagTypes: ['employments', 'users'],
    endpoints: builder => ({

        // POST New Employee
        registerNewEmployee: builder.mutation({
            query: ({
                username,
                name,
                surname,
                email,
                password,
                roleGuid,
                roleLabel,
                businessUnitGuid
            }) => ({
                url: 'company/employees',
                method: 'POST',
                body: {
                    username,
                    name,
                    surname,
                    email,
                    password,
                    roleGuid,
                    roleLabel,
                    businessUnitGuid
                }
            }),
            invalidatesTags: ['employments', "users"]
        }),

        // GET Employees
        getEmployees: builder.query({
            query: () => 'company/employees',
            providesTags: ['employments']
        }),

        // GET Employee by GUID
        getEmployee: builder.query({
            query: userGUID => {
                return {
                    url: 'company/employees',
                    params: { userGUID }
                }
            },
            providesTags: ['employments']
        }),

        // PUT Employee New Status
        setEmployeeStatus: builder.mutation({
            query: ({
                newStatus,
                userGuid
            }) => ({
                url: 'company/employees/status',
                method: 'PUT',
                body: {
                    newStatus: newStatus,
                    userGuid: userGuid
                }
            }),
            invalidatesTags: ['employments']
        }),

        // PUT Employee Edit
        editEmployee: builder.mutation({
            query: ({
                userProfile,
                roleGuid,
                roleLabel,
                businessUnitGuid,
                newPassword,

            }) => ({
                url: 'company/employees',
                method: 'PUT',
                body: {
                    user: userProfile,
                    roleGuid,
                    roleLabel,
                    businessUnitGuid,
                    newPassword
                }
            }),
            invalidatesTags: ['employments']
        }),

        // DELETE Employee 
        deleteEmployee: builder.mutation({
            query: userGUID => {
                return {
                    url: 'company/employees',
                    method: 'DELETE',
                    params: { userGUID }
                }
            },
            invalidatesTags: ['employments']
        }),
    })
})

export const {
    useRegisterNewEmployeeMutation,
    useGetEmployeesQuery,
    useGetEmployeeQuery,
    useEditEmployeeMutation,
    useSetEmployeeStatusMutation,
    useDeleteEmployeeMutation
} = employmentApiSlice